<template>
    <div>
        <el-row style="font-size: 20px;color:#999999;border: 1px solid #eee;">
            <el-col :span="12" >
                <p style="height: 100%;line-height: 100px;text-align: center;border-right: 1px solid #eee;">
                    第三方服务可用余额<span style="color:#409EFF;font-size: 30px;font-weight: bold;margin-left: 10px;margin-right: 10px;"> {{accountInfo.canUsedMoney/100}}</span> 元</p>
            </el-col>
            <el-col :span="12">
                <div style="height: 100%;line-height: 100px;text-align: center;">
                    累计充值第三方服务 <span style="color: #1E1E1E;">{{accountInfo.totalMoney/100}}</span> 元
                    |
                    累计支出第三方服务 <span style="color: #1E1E1E;">{{accountInfo.usedMoney/100}}</span> 元
                </div>
            </el-col>

        </el-row>
        <p style="color: #FF9900;margin-top: 20px;margin-bottom: 20px;">温馨提示：当第三方服务账户余额不足时，将会影响第三方服务（维保查询、碰撞查询等业务）的正常运行，请联系运营方及时充值保障余额充足。</p>

        <div class="Echarts">
            <div id="main" style="width: 100%;height:400px;"></div>
        </div>
    </div>
</template>
<script>
import distributor from '@/framework/models/distributor'
import echarts from 'echarts'
export default {
  name: 'other-service-account',
  data () {
    return {
      accountInfo: {}
    }
  },
  created () {
    this.selectDistributorAccount()
  },
  mounted () {
    this.findDbtThirdPartyToolsConsumeRecordStatistics()
  },
  methods: {
    myEcharts (statistics) {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('main'))

      // 指定图表的配置项和数据
      var option = {
        title: {
          text: '近30天消耗趋势'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        // legend: {
        //     data:['销量']
        // },
        xAxis: {
          data: statistics.date
        },
        yAxis: {},
        series: [{
          name: '消耗量',
          color: '#409EFF',
          type: 'bar',
          data: statistics.data
        }]
      }

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option)
    },

    findDbtThirdPartyToolsConsumeRecordStatistics () {
      let _this = this
      let params = {}
      let listener = {
        success (dataInfo) {
          let datas = dataInfo.datas
          let date = []
          let data = []
          for (let i = 0; i < datas.length; i++) {
            let item = datas[i]
            date.push(item.date)
            data.push(item.money)
          }

          let statistics = {
            date: date,
            data: data
          }

          _this.myEcharts(statistics)
        }
      }
      distributor.findDbtThirdPartyToolsConsumeRecordStatistics(this, params, listener)
    },
    selectDistributorAccount () {
      let _this = this
      let params = {}
      let listener = {
        success (dataInfo) {
          _this.accountInfo = dataInfo.datas
        }
      }
      distributor.selectDistributorAccount(this, params, listener)
    }
  }
}
</script>
